import { useTranslator } from '@bluebeam/react-i18n';
import FilterSection from 'components/FilterPopover/FilterSection';
import Checkbox from 'components/inputs/Checkbox';
import AppStoreContext from 'contexts/AppStoreContext';
import snakeCase from 'lodash/snakeCase';
import React, { useContext } from 'react';
import { SheetQuery } from 'records/SheetQuery';
import { SheetVersion } from 'records/SheetVersion';

interface Props {
  sheetQuery: SheetQuery;
  updateSheetQuery: (nextSheetQuery: SheetQuery) => void;
}

const RevCommentFilterSection: React.FC<Props> = (props: Props) => {
  const { translate } = useTranslator(['revCommentFilterSection']);
  const { sheetQuery, updateSheetQuery } = props;
  const { state: appState } = useContext(AppStoreContext);

  // get all revision comments
  const revisionComments = appState.sheets
    .valueSeq()
    .map((s) => s.versions.last(new SheetVersion()).get('revisioncomment'))
    .filter(Boolean)
    .toSet()
    .sortBy((rc) => rc.toLocaleLowerCase());

  /* Handlers */
  function onCheckboxChange(rc: string) {
    const nextSheetQuery = sheetQuery.update('revisionComments', (rcs) => {
      return rcs.has(rc) ? rcs.delete(rc) : rcs.add(rc);
    });

    updateSheetQuery(nextSheetQuery);
  }

  const appliedFilters = sheetQuery.revisionComments
    .sortBy((rc) => rc.toLocaleLowerCase())
    .toArray();

  return (
    <FilterSection
      label={translate('revCommentFilterSection:revisionComment')}
      appliedFilters={appliedFilters}
      disabled={revisionComments.size === 0}
    >
      <div className="h100 oa px4 py3">
        {revisionComments.map((rc) => {
          return (
            <div
              key={rc}
              className="row mb3 cursor-pointer disable-select"
              onClick={() => onCheckboxChange(rc)}
            >
              <Checkbox
                id={`drawings-filter-popover-revcom-checkbox-${snakeCase(rc)}`}
                onChange={() => onCheckboxChange(rc)}
                checked={sheetQuery.revisionComments.has(rc)}
              />
              <div className="ml2 mr4 truncate">{rc}</div>
            </div>
          );
        })}
      </div>
    </FilterSection>
  );
};

export default RevCommentFilterSection;
